import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

export default function DynamicLink() {
  const path = window.location.pathname.split('/').pop();
  const navigate = useNavigate();
  const [data, setData] = useState<any[] | null>(null);
  const [checked, setChecked] = useState(false); // <-- nuevo estado para marcar que ya se procesó

  useEffect(() => {
    async function fetchRedirect() {
      try {
        const res = await fetch(`https://api.castellersdemollet.cat/dynamicLinks`);
        if (!res.ok) throw new Error('No se pudo obtener el redireccionamiento');
        const data = await res.json();
        setData(data);
      } catch (err) {
        console.error('Error al obtener redirección:', err);
        navigate('/404');
      }
    }
    fetchRedirect();
  }, [navigate]);

  useEffect(() => {
    if (!data || checked) return;
    const item = data.find((item: any) => item.path === path);
    setChecked(true); // marcar como procesado, para evitar bucles infinitos
    if (!item?.redirect) return navigate('/404');
    const redirect = item.redirect;
    if (redirect.startsWith('https://')) {
      window.location.href = redirect;
    } else if (redirect.startsWith('/')) {
      navigate(redirect);
    } else {
      navigate('/404'); // fallback
    }
  }, [data, path, navigate, checked]);
  return null;
}